/* eslint-disable no-unused-vars */
import { apolloClient } from "@/setup/apollo-setup";

import * as generic from "@/store/generic/mutations/result-status.js";

// import { getCourseOutlineById } from "@/services/api/course-outline";

import {
    GET_CLASSSECTION,
    GET_CLASSSECTIONS,
    GET_CLASSSECTIONS_BY_FILTER,
    ADD_CLASSSECTION,
    UPDATE_CLASSSECTION,
    DELETE_CLASSSECTION
} from '@/queries/modules/courses/class-section.js';

const state = {};

const getters = {};

const mutations = {};

const actions = {


/**
  *  Action to Get Class Section List
  *
  *   @param  {Object} context Vuex context object.
  *     @property {Vuex method (Function)} commit : "To commit a mutation"
  *
  */

  async getClassSections({commit}) {
    // commit('setProcessing', true);
    try {
      const result = await apolloClient
      .query({
        query: GET_CLASSSECTIONS,
        fetchPolicy: 'network-only'
      })
      const { data } = await result;

      // TODO: Handle after success;
      return { status: { success: true, error: false, message: "" }, data: [ ...data.getClassSections ] };

    } catch (e) {
      // commit('setError', error(e));
      return { status: { success: false, error: true, message: "", full: e }};
    }
  },


/**
  *  Action to Get Class Section By ID
  *
  *   @param  {Object} context Vuex context object.
  *     @property {Vuex method (Function)} commit : "To commit a mutation"
  *
  */

  async getClassSection({commit}) {
    // commit('setProcessing', true);
    try {
      const result = await apolloClient
      .query({
        query: GET_CLASSSECTION,
        fetchPolicy: 'network-only'
      })
      const { data } = await result;

      // TODO: Handle after success;
      return { status: { success: true, error: false, message: "" }, data: [ ...data.getClassSection ] };

    } catch (e) {
      // commit('setError', error(e));
      return { status: { success: false, error: true, message: "", full: e }};
    }
  },


/**
  *  Action to Get Class Section By Filter
  *
  *   @param  {Object} context Vuex context object.
  *     @property {Vuex method (Function)} commit : "To commit a mutation"
  *
  */

  async getClassSectionByFilter({commit}) {
    // commit('setProcessing', true);
    try {
      const result = await apolloClient
      .query({
        query: GET_CLASSSECTIONS_BY_FILTER,
        fetchPolicy: 'network-only'
      })
      const { data } = await result;

      // TODO: Handle after success;
      return { status: { success: true, error: false, message: "" }, data: [ ...data.getClassSectionByFilter ] };

    } catch (e) {
      // commit('setError', error(e));
      return { status: { success: false, error: true, message: "", full: e }};
    }
  },


/**
  *  Action to Add Class Section
  *
  *   @param  {Object} context Vuex context object.
  *     @property {Vuex method (Function)} commit : "To commit a mutation"
  *
  *   @param  {Object} payload Contain requires inputs for adding data
  *     @property {ID (String), required } courseOutlineId
  *     @property {ID (String), required } courseOutlineRegistrationId
  *     @property {ID (String), required } vdoSetId
  *     @property {ClassSectionInput (Array), required} classSectionInput : {
          sectionNo: 0,         // {Int}    Get it from form input.
          studentQty: 0,        // {Int}    Get it from form input.
          vdoSetCode: ""        // {String} Get it from selector handler.
          startClassDate: ""    // {String} Get it from date picker, format: "YYYY/MM/DD".
          learnSpanNo: 0        // {Int}    Get it from radio selector: 1 or 2.
          examSpanNo: 0         // {Int}    ?UNKNOWN Empty, Fill with 0.
          descriptionLocal: "", // {String} Get it from form input.
          descriptionEng: "",   // {String} Get it from form input.
        }
  *
  */

  async addClassSection({ commit }, payload) {
    // commit('setProcessing', true);
    try {
      const result = await apolloClient
      .mutate({
        mutation: ADD_CLASSSECTION,
        variables: payload
      })
      const { data } = await result;

      return {
        status: { success: true, error: false, message: "" },
        data: { ...data.addClassSection }
      };

    } catch (e) {
      // commit('setError', error(e));
      return { status: { success: false, error: true, message: "", full: e }};
    }
  },


/**
  *  Action to Update Class Section.
  *
  *   @param  {Object} context Vuex context object.
  *     @property {Vuex method (Function)} commit : "To commit a mutation"
  *
  *   @param  {Object} payload Contain requires inputs for updating data
  *
  */

  async updateClassSection({ commit }, payload) {
    // commit('setProcessing', true);
    try {
      const result = await apolloClient
      .mutate({
        mutation: UPDATE_CLASSSECTION,
        variables: payload
      })
      const { data } = await result;

      return {
        status: { success: true, error: false, message: "" },
        data: { ...data.updateClassSection }
      };

    } catch (e) {
      // commit('setError', error(e));
      return { status: { success: false, error: true, message: "", full: e }};
    }
  },


/**
  *  Action to Delete Course Outline Registration
  *
  *   @param  {Object} context Vuex context object.
  *     @property {Vuex method (Function)} commit : "To commit a mutation"
  *
  *   @param  {Object} payload Contain requires inputs for adding data
  *     @property {ID (String), required} id : "ID of a Class Section"
  *
  */

  async deleteClassSection({ commit }, payload) {
    // commit('setProcessing', true);
    try {
      const result = await apolloClient
      .mutate({
        mutation: DELETE_CLASSSECTION,
        variables: payload
      })
      const { data } = await result;

      // TODO: Handle after success;
      return data;
    } catch (e) {
      // commit('setError', error(e));
      return { status: { success: false, error: true, message: "", full: e }}
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
